import { render } from "./gateway_page.vue?vue&type=template&id=50c40032&scoped=true"
import script from "./gateway_page.vue?vue&type=script&lang=js"
export * from "./gateway_page.vue?vue&type=script&lang=js"

import "./gateway_page.vue?vue&type=style&index=0&id=50c40032&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50c40032"]])

export default __exports__